<script lang="ts">
    import { onMount } from "svelte";
    import { appstates } from "../../stores/app-state";
    import { RequirementStore } from "../../stores/requirement-store";
    import Step from "../common/step.component.svelte";
    import OutlineButton from "../common/outline-button.component.svelte";
    import InputBox from "../ui/InputBox.svelte";
    import AddIcon from "../ui/icons/icon-add.svelte";
    import ListWidthDelete from "../ui/list-with-delete.svelte";

    // Export
    export let title: string = "";

    // Vars
    // -- List of stakes
    let stakes: string[] = [];
    // -- The current test
    let currentStake: string = "";

    // Reactive
    // --- Add button enabled
    $: btnAddEnabled = currentStake.trim().length >= 5;
    // -- Next possible ?
    $: nextEnable = stakes.length >= 2;

    // Function
    // -- onMount
    onMount(() => {
        stakes = RequirementStore.getStakes();
    });
    // -- Handle a new Stake
    const handleNewStake = () => {
        if (btnAddEnabled) {
            // Record in the list
            stakes = [...stakes, currentStake];
            // Clear the text
            currentStake = "";
        }
    };
    // -- Handle ask for delete a stake
    const handleDeleteStake = (stake: string) => {
        // Filter
        stakes = stakes.filter((s) => s !== stake);
    };

    // Calc : can we go to next

    // Functions

    const handleNext = () => {
        // Check
        if (nextEnable) {
            RequirementStore.updateStakes(stakes);
            appstates.next();
        }
    };
</script>

<Step
    {title}
    {nextEnable}
    on:navigation-next={handleNext}
    imageIndex={$appstates}
>
    <span slot="presentation">
        Votre projet doit répondre à des enjeux qui doivent rester au coeur de
        vos attentes. Afin que cela reste une base solide, ils ne doivent pas
        être multipliés et simplement exprimés.
    </span>
    <svelte:fragment slot="content">
        <div class="content">
            <InputBox>
                <input
                    type="text"
                    bind:value={currentStake}
                    placeholder="Un nouvel enjeu pour votre projet ?"
                    on:keydown={(e) => {
                        if (btnAddEnabled && e.key == "Enter") {
                            handleNewStake();
                        }
                    }}
                />
                <OutlineButton on:click={handleNewStake} disabled={!btnAddEnabled}>
                    <AddIcon />
                </OutlineButton>
            </InputBox>
            <small class="help"> Au moins deux enjeux. Chaque enjeu doit faire 5 caractères </small>
            <!-- <div>
                <ul>
                    {#each stakes as stake}
                        <li transition:fade|local>
                            <OutlineButton on:click={() => handleDeleteStake(stake)}>
                                <RemoveIcon />
                            </OutlineButton>
                            <span> {stake} </span>
                        </li>
                    {/each}
                </ul>
            </div> -->
            <ListWidthDelete
                    list={stakes}
                    on:delete={(e) => { handleDeleteStake(e.detail) }}
                        />
        </div>
    </svelte:fragment>
</Step>

